export default __webpack_public_path__ + "static/ThunderTee-b6daaad52a474c348466fbd939fe49e7.svg";